import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToDirectRegistation && _ctx.goToDirectRegistation(...args))),
    class: "Email",
    "data-cy": "DirectLogin",
    type: "button"
  }, " Continue with email "))
}